import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",

    primary: {
      light: "#6FD9F0",     // lighter shade
      main: "#8B5CF6",      // base color you gave
      dark: "#2590A6",
      contrastText: "#ffffff",
    },

    secondary: {
      light: "#99CFFF",
      main: "#004DE3",
      dark: "#0033A8",
      contrastText: "#ffffff",
    },

    accent: {
      main: "#4CAF50",
    },

    background: {
      default: "#F9F9F9",
      paper: "#ffffff",
    },

    text: {
      primary: "#333333",
      secondary: "#666666",
      disabled: "#D0D5DD",
    },

    error: {
      light: "#FFD8D8",
      main: "#FF4D4D",
      dark: "#C63939",
    },

    warning: {
      light: "#FFF8E1",
      main: "#FFE57F",
      dark: "#FFC107",
      contrastText: "#000000",
    },

    success: {
      light: "#B9F6CA",
      main: "#00E676",
      dark: "#00C853",
      contrastText: "#ffffff",
    },

    grey: {
      25: "#FCFCFD",
      50: "#F9FAFB",
      100: "#F2F4F7",
      200: "#EAECF0",
      300: "#D0D5DD",
      400: "#98A2B3",
      500: "#667085",
      600: "#475467",
      700: "#344054",
      800: "#1D2939",
      900: "#101828",
    },

    common: {
      black: "#000000",
      white: "#ffffff",
      gray: "#808080",
    },
  },

  typography: {
    fontFamily: 'Inter, sans-serif',
    h1: {
      fontSize: "3.75rem", // 60px
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: "3rem", // 48px
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: "2.25rem", // 36px
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: "1.875rem", // 30px
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: "1.5rem", // 24px
      fontWeight: 500,
      lineHeight: 1.5,
    },
    h6: {
      fontSize: "1.25rem", // 20px
      fontWeight: 500,
      lineHeight: 1.6,
    },
    body1: {
      fontSize: "1rem", // 16px
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "0.875rem", // 14px
      fontWeight: 400,
      lineHeight: 1.6,
    },
    subtitle1: {
      fontSize: "0.875rem", // 14px
      fontWeight: 500,
      lineHeight: 1.75,
    },
    subtitle2: {
      fontSize: "0.75rem", // 12px
      fontWeight: 500,
      lineHeight: 1.57,
    },
    button: {
      fontSize: "0.875rem", // 14px
      fontWeight: 600,
      lineHeight: 1.75,
      textTransform: "uppercase",
    },
    caption: {
      fontSize: "0.75rem", // 12px
      fontWeight: 400,
      lineHeight: 1.66,
    },
    overline: {
      fontSize: "0.625rem", // 10px
      fontWeight: 400,
      lineHeight: 2.2,
      textTransform: "uppercase",
    },
  },

  spacing: 8, // Default spacing (1 unit = 8px)

  shape: {
    borderRadius: 8, // Default border radius for buttons, cards, etc.
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "&::-webkit-scrollbar": {
          width: '5px',
          height: '0px',
          position: 'absolute'
        },
        "&::-webkit-scrollbar-track": {
          borderRadius: "8px"
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#aaaaaa55",
          borderRadius: '8px',
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#aaaaaa",
          borderRadius: "8px",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.default,
          boxShadow: "none",
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "0.375rem",
          textTransform: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "16px", // Rounded corners for cards
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)", // Subtle shadow
        },
      },
    },
  },
});

export default theme;